"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableBodyStyles = void 0;
const Utils_1 = require("../../../utils/Utils");
exports.getTableBodyStyles = (0, Utils_1.createStyleSheet)((theme) => ({
    container: {
        width: '100%',
        height: 'fit-content',
        backgroundColor: theme.colors.$background100,
    },
}), { name: 'Blueprint-TableBody' });
